import { postGenericEndpoint } from './post.api';

import type {
    PostFriendFamilyFindRequest,
    PostFriendFamilyFindResponse,
    PostFriendFamilyNewRequest,
    PostFriendFamilyNewResponse,
} from './types';
import type { PostGenericEndpointParams } from './post.api';

export const postFriendsFamilyFind = async (
    { data, lang, token }: PostGenericEndpointParams<PostFriendFamilyFindRequest>
) => {
    return await postGenericEndpoint<PostFriendFamilyFindRequest, PostFriendFamilyFindResponse>(
        { data, path: 'friends-and-family/find', lang, token }
    );
};

export const postFriendsFamilyNew = async (
    { data, lang, token }: PostGenericEndpointParams<PostFriendFamilyNewRequest>
) => {
    return await postGenericEndpoint<PostFriendFamilyNewRequest, PostFriendFamilyNewResponse>(
        { data, path: 'friends-and-family/new', lang, token }
    );
};
